import Paragraph from '@tiptap/extension-paragraph'

export default Paragraph.extend({
  addAttributes () {
    return {
      ...this.parent?.(),
      type: { default: 'paragraph', rendered: false }
    }
  }
})